"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsharedIllustration = exports.ErrorIllustration = exports.UnsavedIllustration = exports.Unresolve = exports.Resolve = exports.Edit = exports.Delete = exports.NoAccess = exports.FilterIllustration = exports.CommentIllustration = exports.ShareIllustration = exports.replaceIcon = exports.insertIcon = exports.visibilityOffIcon = exports.visibilityIcon = exports.filterBadgeIcon = exports.highlightIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var highlightIcon = /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "-811 7301 18 18",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}, /*#__PURE__*/_react.default.createElement("path", {
  "data-name": "Path 483",
  d: "M-806.29 7310.66l3.5 3.177c-.106.117-.2.22-.273.294a1.224 1.224 0 0 1-.858.249h-.137a4.805 4.805 0 0 0-3.008 1.447l-.771-.639a5.877 5.877 0 0 0 1.054-3.321 1.474 1.474 0 0 1 .249-.937 3.574 3.574 0 0 1 .244-.27zm8.253-8.335l-7.986 6.522s-1.263 1.1-1.395 1.231a2.607 2.607 0 0 0-.586 1.886 5.045 5.045 0 0 1-.983 2.744l-1.614 1.9a.209.209 0 0 0 .115.376l2.782.765a.723.723 0 0 0 .638-.188l.29-.331a4.718 4.718 0 0 1 2.721-1.629h.137a2.39 2.39 0 0 0 1.732-.616c.114-.116.267-.285.427-.467.062-.024 7.086-9.02 7.086-9.02a1.05 1.05 0 0 0-.159-1.518l-1.68-1.609a1.049 1.049 0 0 0-1.525-.046zm-7.986 6.522z"
}));

exports.highlightIcon = highlightIcon;

var filterBadgeIcon = /*#__PURE__*/_react.default.createElement("svg", {
  id: "S_Filter_24_N_1x",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  d: "M0 3h18v18H0z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.5 20.5c-.1 0-.2 0-.2-.1-.2 0-.3-.2-.3-.5v-7.6L1.1 4.8c-.1-.1-.1-.3 0-.5s.2-.3.4-.3H10c0 2 1.1 3.7 2.9 4.6L10 12.3v5.6c0 .2-.1.3-.2.4l-2 2.1c-.1 0-.2.1-.3.1z"
}), /*#__PURE__*/_react.default.createElement("circle", {
  className: "badge",
  cx: "15",
  cy: "4",
  r: "4"
}));

exports.filterBadgeIcon = filterBadgeIcon;

var visibilityIcon = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.3,12.714c0-2.046,3.7-6.214,8-6.214a7.089,7.089,0,0,1,1.7.21V6a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,6v6.471a2.5,2.5,0,0,0,2.5,2.5H3v4.5a.5.5,0,0,0,.854.354L8.519,15.3A3.913,3.913,0,0,1,7.3,12.714Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.029,8.678A6.18,6.18,0,0,0,15.3,8c-3.576,0-6.5,3.56-6.5,4.715,0,1.236,3.078,4.417,6.474,4.417,3.423,0,6.526-3.181,6.526-4.417C21.8,11.739,20.061,9.685,18.029,8.678Zm-2.729,7.7a3.807,3.807,0,1,1,3.807-3.807A3.807,3.807,0,0,1,15.3,16.373Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.4,12.6a1.1,1.1,0,0,1-1.1-1.1,1.086,1.086,0,0,1,.557-.937,2.045,2.045,0,0,0-.557-.086,2.089,2.089,0,1,0,2.089,2.089,1.906,1.906,0,0,0-.072-.493A1.082,1.082,0,0,1,16.4,12.6Z"
})));

exports.visibilityIcon = visibilityIcon;

var visibilityOffIcon = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.574,13.862l-.23.236L4.5,17.009V14.471a1,1,0,0,0-1-1h-1a1,1,0,0,1-1-1V6a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v.515a7.736,7.736,0,0,1,1.5.2V6a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,6v6.471a2.5,2.5,0,0,0,2.5,2.5H3v4.534a.5.5,0,0,0,.859.348l4.572-4.718A5.656,5.656,0,0,1,7.574,13.862Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.48,17.991,17.1,13.615a2.085,2.085,0,0,0,.285-1.05,1.967,1.967,0,0,0-.073-.494,1.08,1.08,0,0,1-.916.528,1.1,1.1,0,0,1-1.1-1.1,1.083,1.083,0,0,1,.557-.936,2.029,2.029,0,0,0-.557-.087,2.078,2.078,0,0,0-1.05.284L9.874,6.384a.357.357,0,0,0-.5,0l-.25.25a.356.356,0,0,0,0,.5h0l2.256,2.256C9.814,10.523,8.8,12.033,8.8,12.712c0,1.237,3.078,4.417,6.473,4.417a6.788,6.788,0,0,0,3.05-.788l2.4,2.4a.355.355,0,0,0,.5,0h0l.25-.25A.356.356,0,0,0,21.48,17.991ZM15.3,16.373a3.8,3.8,0,0,1-3.039-6.091L13.5,11.516a2.086,2.086,0,0,0,2.854,2.854l1.234,1.235A3.781,3.781,0,0,1,15.3,16.373Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14,8.991a3.8,3.8,0,0,1,4.874,4.874l1.259,1.258A4.283,4.283,0,0,0,21.8,12.714c0-.975-1.739-3.029-3.771-4.036A6.169,6.169,0,0,0,15.3,8a5.888,5.888,0,0,0-1.946.343Z"
})));

exports.visibilityOffIcon = visibilityOffIcon;

var insertIcon = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.5 2C14.7761424 2 15 2.22385763 15 2.5L15 2.5 15 5.5C15 5.77614237 14.7761424 6 14.5 6L14.5 6 13.5 6C13.2238576 6 13 5.77614237 13 5.5L13 5.5 13 4 9 4 9 13 9.991 13 9.07376 13.8827459C9 13.9561859 9 14.0315459 9 14.1062659L9 15 5.5 15C5.25454011 15 5.05039163 14.8231248 5.00805567 14.5898756L5 14.5 5 13.5C5 13.2238576 5.22385763 13 5.5 13L5.5 13 7 13 7 4 3 4 3 5.5C3 5.77614237 2.77614237 6 2.5 6L2.5 6 1.5 6C1.22385763 6 1 5.77614237 1 5.5L1 5.5 1 2.5C1 2.22385763 1.22385763 2 1.5 2L1.5 2zM14.0032 10.6003459C13.91136 10.6003459 13.82 10.6374659 13.74688 10.7133059L10.07376 14.4456259C10 14.5190659 10 14.5944259 10 14.6691459L10 16.6272259C10 16.8510659 10.1472 17.0003459 10.36752 17.0003459L11.96752 17.0003459C12.1136 17.0003459 12.18704 17.0003459 12.26016 16.9257859L14.0152 15.1062659 15.7336 16.9257859C15.80672 17.0003459 15.95392 17.0003459 16.02688 17.0003459L17.65152 17.0003459C17.87184 17.0003459 17.97728 16.9269059 18 16.6272259L18 14.6691459C18 14.5952259 18 14.5203459 17.92656 14.4456259L14.26096 10.7133059C14.18752 10.6374659 14.09536 10.6003459 14.0032 10.6003459z"
})));

exports.insertIcon = insertIcon;

var replaceIcon = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M8.5 14L8 14 8 11 6 11 6 14 4.5 14C4.22385763 14 4 14.2238576 4 14.5L4 15.5C4 15.7761424 4.22385763 16 4.5 16L8.5 16C8.77614237 16 9 15.7761424 9 15.5L9 14.5C9 14.2238576 8.77614237 14 8.5 14zM13.5 2L.5 2C.223857625 2 0 2.22385763 0 2.5L0 5.5C0 5.77614237.223857625 6 .5 6L1.5 6C1.77614237 6 2 5.77614237 2 5.5L2 4 6 4 6 8 8 8 8 4 12 4 12 5.5C12 5.77614237 12.2238576 6 12.5 6L13.5 6C13.7761424 6 14 5.77614237 14 5.5L14 2.5C14 2.22385763 13.7761424 2 13.5 2zM.25 9L8.75 9C8.88807119 9 9 9.11192881 9 9.25L9 9.75C9 9.88807119 8.88807119 10 8.75 10L.25 10C.111928813 10 1.69088438e-17 9.88807119 0 9.75L0 9.25C-1.69088438e-17 9.11192881.111928813 9 .25 9z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.9825422,11.2222224 C11.9825422,11.0994668 12.0819201,11 12.2047647,11 L15.7934992,11 C15.9163438,11 16.0157216,11.0994668 16.0157216,11.2222224 L16.0157216,11.7873744 C16.0157216,11.9101301 15.9163438,12.0095968 15.7934992,12.0095968 L12.2047647,12.0095968 C12.0819201,12.0095968 11.9825422,11.9101301 11.9825422,11.7873744 L11.9825422,11.2222224 Z M11.9798416,13.2080442 C11.9798416,13.0852885 12.0792195,12.9858218 12.202064,12.9858218 L14.7880015,12.9858218 C14.9108461,12.9858218 15.010224,13.0852885 15.010224,13.2080442 L15.010224,13.7834682 C15.010224,13.9062238 14.9108461,14.0056906 14.7880015,14.0056906 L12.202064,14.0056906 C12.0792195,14.0056906 11.9798416,13.9062238 11.9798416,13.7834682 L11.9798416,13.2080442 Z M17.111147,9 L10.8889193,9 C10.40083,8.99573333 10.0065186,9.39644479 9.99995665,9.88888966 L9.99995665,14.9999784 C9.99718522,15.4924233 10.4017189,15.884068 10.8889193,15.888868 L12.0103767,15.888868 C12.0103767,15.888868 12.0268212,17.1360072 12.0281545,17.7845411 C12.0287767,18.0298746 12.1787324,18.0879191 12.3523326,17.9144078 C12.965222,17.3015184 14.4709353,15.888868 14.4709353,15.888868 L17.111147,15.888868 C17.6778141,15.888868 17.9982588,15.4881566 18.0000967,14.9999784 L18.0000967,9.88888966 C18.0026144,9.39777812 17.5979029,9.00293334 17.111147,9 Z"
})));

exports.replaceIcon = replaceIcon;

var ShareIllustration = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "58",
  height: "99",
  viewBox: "0 0 37.943 66.219",
  className: "ccx-share-illustration"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Group_68966",
  "data-name": "Group 68966",
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M1118.438-2655.353a4.909,4.909,0,0,1,.374-2.569,8.872,8.872,0,0,1,1.4-2.127,5.386,5.386,0,0,0,1.218-3.815c-.048-.694-.948-5.764-.99-6.268a3.932,3.932,0,0,1,.365-2.557,2.333,2.333,0,0,1,.71-.628,1.365,1.365,0,0,1,2.1.837c.893,3.053,2.5,8.429,3.15,11.544a23.979,23.979,0,0,1,.514,3.412c.263,4.271-1.362,8.417-1.856,12.668l.121,2.7",
  transform: "translate(-1101.709 2705.306)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M1108.448-2632.69c-.139-4.117-.653-3.5-1.834-5.785-.522-1.009-1.152-1.982-1.646-3a7.484,7.484,0,0,1-.74-3.267l.5-6.247",
  transform: "translate(-1095.399 2695.838)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M1105.972-2688.688h-13.4a4.048,4.048,0,0,1-4.075-4.02v-34.772a4.047,4.047,0,0,1,4.075-4.02h20.287a4.512,4.512,0,0,1,3.174,1.3l6.1,6.032a4.392,4.392,0,0,1,1.309,3.123v28.337a4.048,4.048,0,0,1-4.075,4.02h-3.252",
  transform: "translate(-1088.5 2731.5)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3"
}), /*#__PURE__*/_react.default.createElement("line", {
  id: "Line_39",
  "data-name": "Line 39",
  x2: "21.471",
  transform: "translate(6.197 30.716)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), /*#__PURE__*/_react.default.createElement("line", {
  id: "Line_40",
  "data-name": "Line 40",
  x2: "10.445",
  transform: "translate(6.403 35.225)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), /*#__PURE__*/_react.default.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  x2: "2.321",
  transform: "translate(25.029 35.225)",
  fill: "none",
  stroke: "#909090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}))));

exports.ShareIllustration = ShareIllustration;

var CommentIllustration = function CommentIllustration(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size === 'M' ? 72 : 120,
    height: size === 'M' ? 56 : 93,
    viewBox: "0 0 72 56",
    className: "ccx-comment-illustration"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M44,18.75H19a.75.75,0,0,1,0-1.5H44a.75.75,0,0,1,0,1.5Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37,24.75H19a.75.75,0,0,1,0-1.5H37a.75.75,0,0,1,0,1.5Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.00391,44.76465A2.00777,2.00777,0,0,1,21,42.7627V35H14a5.00588,5.00588,0,0,1-5-5V12a5.00588,5.00588,0,0,1,5-5H49a5.00588,5.00588,0,0,1,5,5V30a5.00588,5.00588,0,0,1-5,5H33.103l-8.65088,9.1377A1.99246,1.99246,0,0,1,23.00391,44.76465ZM14,9a3.00328,3.00328,0,0,0-3,3V30a3.00328,3.00328,0,0,0,3,3h8a.99974.99974,0,0,1,1,1v8.7627l8.94678-9.4502A1.00064,1.00064,0,0,1,32.67285,33H49a3.00328,3.00328,0,0,0,3-3V12a3.00328,3.00328,0,0,0-3-3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.99512,50.21582a1.98957,1.98957,0,0,1-1.46582-.64648L40.47559,43H32a6.9751,6.9751,0,0,1-2.334-.39941.99982.99982,0,0,1,.668-1.88477A4.97724,4.97724,0,0,0,32,41h8.91406a1.00164,1.00164,0,0,1,.73535.32227L48,48.21387V42a.99974.99974,0,0,1,1-1H59a3.00328,3.00328,0,0,0,3-3V24a3.00328,3.00328,0,0,0-3-3H56a1,1,0,0,1,0-2h3a5.00588,5.00588,0,0,1,5,5V38a5.00588,5.00588,0,0,1-5,5H50v5.21387a1.98808,1.98808,0,0,1-1.27246,1.86328A2.00831,2.00831,0,0,1,47.99512,50.21582Z"
  }));
};

exports.CommentIllustration = CommentIllustration;
CommentIllustration.propTypes = {
  size: _propTypes.default.string
};

var FilterIllustration = /*#__PURE__*/_react.default.createElement("svg", {
  width: "74",
  height: "77",
  viewBox: "0 0 50 52",
  className: "ccx-filter-illustration"
}, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "ccx-svg-filter-empty-mask"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M-6006-4106h-39v-47h29.779a10.951 10.951 0 0 0-1.78 6 11.013 11.013 0 0 0 11 11v30z",
  transform: "translate(6353 4543)",
  fill: "#fff"
}))), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#ccx-svg-filter-empty-mask)",
  transform: "translate(-308 -385)"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "ccx-svg-filter-empty-funnel",
  d: "M345.14 395.288h-32.616a1.169 1.169 0 0 0-.922 1.89l13.722 17.51v17.91a1.169 1.169 0 0 0 1.965.964l4.655-4.858a1.429 1.429 0 0 0 .4-.987v-13.029l13.715-17.51a1.169 1.169 0 0 0-.919-1.89z"
})), /*#__PURE__*/_react.default.createElement("path", {
  d: "M39.065 1.427a9.638 9.638 0 1 0 9.638 9.638 9.638 9.638 0 0 0-9.638-9.638zm0 18.071a8.433 8.433 0 1 1 8.433-8.433 8.433 8.433 0 0 1-8.433 8.433z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M37.499 15.521a1.393 1.393 0 0 1 1.448-1.335h.106a1.563 1.563 0 0 1 1.055.307 1.252 1.252 0 0 1 .5.884v.141a1.2 1.2 0 0 1-.451.961 1.524 1.524 0 0 1-1.104.333 1.533 1.533 0 0 1-1.038-.278 1.231 1.231 0 0 1-.513-.853.985.985 0 0 1-.006-.16zm2.874-9.835a.234.234 0 0 1 .13.212v1.2c0 1.623-.367 4.613-.432 5.193 0 .058-.022.116-.152.116h-1.728a.139.139 0 0 1-.152-.116c-.043-.537-.386-3.508-.386-5.129V5.954a.2.2 0 0 1 .1-.212 4.134 4.134 0 0 1 1.3-.232 4.712 4.712 0 0 1 1.319.176z"
}));

exports.FilterIllustration = FilterIllustration;

var NoAccess = /*#__PURE__*/_react.default.createElement("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 110",
  width: "120",
  className: "ccx-no-access-illustration"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "chat_sm",
  "data-name": "chat sm"
}, /*#__PURE__*/_react.default.createElement("line", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  x1: "77.76",
  y1: "33.32",
  x2: "31.41",
  y2: "33.32"
}), /*#__PURE__*/_react.default.createElement("line", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  x1: "31.41",
  y1: "44.23",
  x2: "59.21",
  y2: "44.23"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M22.12,14.91H87a7.42,7.42,0,0,1,7.42,7.42V55.72A7.42,7.42,0,0,1,87,63.13H56.75L40.16,80.66A1.86,1.86,0,0,1,37,79.39V63.13H22.12a7.42,7.42,0,0,1-7.42-7.41V22.33A7.42,7.42,0,0,1,22.12,14.91Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M113,47.38V44.59a7.42,7.42,0,0,0-7.41-7.42H100"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M51.79,77.34A11.12,11.12,0,0,0,55.5,78H72L83.81,90.75A1.85,1.85,0,0,0,87,89.5V78h3.56"
})), /*#__PURE__*/_react.default.createElement("circle", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  cx: "117.44",
  cy: "73.01",
  r: "20.46"
}), /*#__PURE__*/_react.default.createElement("line", {
  fill: "none",
  stroke: "#b3b3b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  x1: "103.46",
  y1: "58.49",
  x2: "131.17",
  y2: "86.2"
}));

exports.NoAccess = NoAccess;

var Delete = /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.5,6.021a.5.5,0,0,0,.5.5h.5L4.957,19a.5.5,0,0,0,.5.452H16.046a.5.5,0,0,0,.5-.452L18,6.521h.5a.5.5,0,0,0,.5-.5v-.5A.518.518,0,0,0,18.5,5H15V4a1.5,1.5,0,0,0-1.5-1.5H8A1.5,1.5,0,0,0,6.5,4V5H3a.518.518,0,0,0-.5.521Zm8.95,10.2a.725.725,0,0,1-1.45,0V8.725a.725.725,0,0,1,1.45,0Zm2.263-7.542a.725.725,0,0,1,1.444.133l-.683,7.459a.725.725,0,1,1-1.444-.132ZM8,4h5.5V5H8ZM7,8.019a.725.725,0,0,1,.788.655l.683,7.46a.725.725,0,1,1-1.444.132L6.343,8.807A.724.724,0,0,1,7,8.019Z"
}));

exports.Delete = Delete;

var Edit = /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.949,19.435a.122.122,0,0,0,.034,0c.156-.036,4.427-1.319,5.24-1.564a.546.546,0,0,0,.234-.14L19.211,6.973a.77.77,0,0,0,.227-.5.687.687,0,0,0-.2-.533L16,2.7a.685.685,0,0,0-.488-.2h-.021a.773.773,0,0,0-.522.229L4.213,13.483a.557.557,0,0,0-.142.236L2.508,18.956C2.444,19.168,2.767,19.435,2.949,19.435Zm2.16-5.257,2.656,2.649c-1.216.366-2.736.825-3.786,1.138Z"
}));

exports.Edit = Edit;

var Resolve = /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20,5.068A2.041,2.041,0,0,0,17.986,3H4.031A2.041,2.041,0,0,0,2.015,5.054L2,13.94A2.041,2.041,0,0,0,4.016,16H7.007v4.736a.252.252,0,0,0,.246.257.267.267,0,0,0,.188-.072L12,16h6a2.009,2.009,0,0,0,2-2.019V5.068ZM15.385,7.457l-4.87,5.855a.512.512,0,0,1-.713.076.455.455,0,0,1-.04-.035L6.651,10.541a.494.494,0,0,1,0-.708l0,0,.724-.676a.513.513,0,0,1,.719,0l0,0,1.819,1.705L13.8,6.185a.509.509,0,0,1,.708-.078l.01.007.8.631A.5.5,0,0,1,15.385,7.457Z"
}));

exports.Resolve = Resolve;

var Unresolve = /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M20,5.068A2.041,2.041,0,0,0,17.986,3H4.031A2.041,2.041,0,0,0,2.015,5.054L2,13.94A2.041,2.041,0,0,0,4.016,16H7.007v4.736a.252.252,0,0,0,.246.257h0a.268.268,0,0,0,.184-.072L12,16h6a2.009,2.009,0,0,0,2-2.019V5.068Zm-1.641,9.287a.513.513,0,0,1-.359.154H11.352l-.442.477L8.5,17.588V14.509H4.031a.551.551,0,0,1-.54-.566l.015-8.9a.548.548,0,0,1,.525-.553H17.973a.551.551,0,0,1,.38.166.568.568,0,0,1,.156.411v8.92A.516.516,0,0,1,18.359,14.355Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.529,8.5H7.471A.486.486,0,0,0,7,9v.5a.486.486,0,0,0,.471.5h7.058A.486.486,0,0,0,15,9.5V9A.486.486,0,0,0,14.529,8.5Z"
}));

exports.Unresolve = Unresolve;

var UnsavedIllustration = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118 78",
  height: "79",
  width: "120"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M81.67285,64.7002l-13.125-.001a1,1,0,0,1,0-2h0l13.125.001c3.90527,0,11.291-2.40918,11.291-11.5254,0-7.041-4.70508-11.875-12.28028-12.61523a.99979.99979,0,0,1-.88281-1.19238,13.22089,13.22089,0,0,0-2.45215-10.35694,1.00015,1.00015,0,0,1,1.61328-1.18261,15.362,15.362,0,0,1,2.97071,10.87158c7.9541,1.188,13.03125,6.77441,13.03125,14.47558C94.96387,61.09863,87.01562,64.7002,81.67285,64.7002Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M50.36133,64.69922h0l-17.46094-.001c-6.77734,0-9.86426-4.76269-9.86426-9.1875a10.19482,10.19482,0,0,1,3.3291-6.97851,8.78238,8.78238,0,0,1,5.043-2.39258C30.169,40.49414,33.60645,34.49121,39.709,32.04053a1.00038,1.00038,0,0,1,.7461,1.85644c-5.57813,2.23926-8.55957,7.897-6.78809,12.8794a1.00034,1.00034,0,0,1-1.01269,1.332,6.61077,6.61077,0,0,0-4.92481,1.88672,8.23622,8.23622,0,0,0-2.69336,5.51562c0,2.66992,1.65625,7.1875,7.86426,7.1875l17.46094.001a1,1,0,1,1,0,2Z"
}))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M59.32227,74.68555a.99942.99942,0,0,1-1-1V47.88867a1,1,0,1,1,2,0V73.68555A.99943.99943,0,0,1,59.32227,74.68555Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M52.377,55.37891a1,1,0,0,1-.706-1.708l6.46777-6.44531a1.68042,1.68042,0,0,1,2.36914,0L66.97363,53.669a.99989.99989,0,1,1-1.41211,1.416l-6.23828-6.2168L53.083,55.08691A.99926.99926,0,0,1,52.377,55.37891Z"
})), /*#__PURE__*/_react.default.createElement("path", {
  d: "M67.54785,34.72119H51.36133a.75.75,0,0,1,0-1.5H67.54785a.75.75,0,0,1,0,1.5Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M67.54785,29.09131H51.36133a.75.75,0,0,1,0-1.5H67.54785a.75.75,0,0,1,0,1.5Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M70.01953,41.08105H48.83105a3.93876,3.93876,0,0,1-3.94238-3.92626V8.97119a3.93866,3.93866,0,0,1,3.94238-3.92578H65.02539a3.97265,3.97265,0,0,1,2.79,1.15283l4.99414,4.98194a3.89031,3.89031,0,0,1,1.15234,2.77294V37.15479A3.93875,3.93875,0,0,1,70.01953,41.08105ZM48.83105,7.04541a1.93608,1.93608,0,0,0-1.94238,1.92578v28.1836a1.93649,1.93649,0,0,0,1.94238,1.92626H70.01953a1.93648,1.93648,0,0,0,1.94238-1.92626V13.95312a1.90415,1.90415,0,0,0-.56445-1.35693L66.40332,7.61377a1.96388,1.96388,0,0,0-1.37793-.56836Z"
}))));

exports.UnsavedIllustration = UnsavedIllustration;

var ErrorIllustration = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118 78",
  height: "79",
  width: "120"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M83.93457,26.56982H41.771a1,1,0,0,1,0-2H83.93457a1,1,0,0,1,0,2Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M67.06055,36.49756H41.771a1,1,0,0,1,0-2H67.06055a1,1,0,0,1,0,2Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M48.50439,70.17383A2.69352,2.69352,0,0,1,45.811,67.48438V53.69824H33.31152a7.75858,7.75858,0,0,1-7.74951-7.75V43.70605a1,1,0,1,1,2,0v2.24219a5.756,5.756,0,0,0,5.74951,5.75H46.811a.99974.99974,0,0,1,1,1V67.48438a.68749.68749,0,0,0,1.18652.47265L64.09473,52.01074a1.00338,1.00338,0,0,1,.72656-.3125H92.37207a5.75608,5.75608,0,0,0,5.75-5.75v-30.374a5.756,5.756,0,0,0-5.75-5.74951H33.31152A5.75587,5.75587,0,0,0,27.562,15.57422V18.2959a1,1,0,1,1-2,0V15.57422a7.75847,7.75847,0,0,1,7.74951-7.74951H92.37207a7.75858,7.75858,0,0,1,7.75,7.74951v30.374a7.75868,7.75868,0,0,1-7.75,7.75H65.25195L50.4502,69.332A2.674,2.674,0,0,1,48.50439,70.17383Z"
})), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.87842,39.56885a1,1,0,0,1-.707-1.707L33.70752,22.32568a.99989.99989,0,1,1,1.41406,1.41407L19.58545,39.27588A.99676.99676,0,0,1,18.87842,39.56885Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M34.41455,39.56885a.99676.99676,0,0,1-.707-.293L18.17139,23.73975a.99989.99989,0,1,1,1.41406-1.41407L35.12158,37.86182a1,1,0,0,1-.707,1.707Z"
})))));

exports.ErrorIllustration = ErrorIllustration;

var UnsharedIllustration = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118 78",
  height: "79",
  width: "120"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M78.918,69.4209H43.9209a5.8028,5.8028,0,0,1-5.86035-5.73047V35.09961a1,1,0,0,1,2,0V63.69043A3.80141,3.80141,0,0,0,43.9209,67.4209H78.918a3.80141,3.80141,0,0,0,3.86035-3.73047V62.45215a1,1,0,0,1,2,0v1.23828A5.80281,5.80281,0,0,1,78.918,69.4209Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M83.77832,42.18066a.99942.99942,0,0,1-1-1V26.17188a3.64548,3.64548,0,0,0-1.11719-2.62452l-8.248-8.05664A3.95648,3.95648,0,0,0,70.669,14.38428H52.78809a1,1,0,0,1,0-2H70.669a5.97226,5.97226,0,0,1,4.1416,1.67578l8.248,8.05664a5.62936,5.62936,0,0,1,1.71973,4.05518V41.18066A.99942.99942,0,0,1,83.77832,42.18066Z"
})))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M92.89062,58.71777a1.62756,1.62756,0,0,1-.84082-.23339L77.27539,49.59766a1.62967,1.62967,0,0,1,.31836-2.94043l23.96582-8.07373a1.00008,1.00008,0,0,1,1.22363,1.375L94.36328,57.78418h0a1.627,1.627,0,0,1-1.47266.93359Zm.56836-1.36035h0Zm-.90332-.42871-.001.002ZM78.99219,48.29688l13.7373,8.26269L99.9707,41.22949Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M84.2666,59.20215a1.54176,1.54176,0,0,1-.54-.09863,1.51442,1.51442,0,0,1-.99218-1.43067V52.31641a1.00059,1.00059,0,0,1,.42382-.81739l18.14453-12.78515a1,1,0,1,1,1.15235,1.63476L84.73438,52.835v3.55859l.55957-.65429a.99949.99949,0,0,1,1.51953,1.29883L85.4209,58.669A1.52525,1.52525,0,0,1,84.2666,59.20215Z"
}))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M24.40039,20.50732c-.01562,0-.03027-.00048-.04492-.00146a5.2627,5.2627,0,1,1,.04883.00146Zm-.001-9.30566a3.90235,3.90235,0,0,0,.00391,7.80469l.02832.00049a3.90268,3.90268,0,0,0-.03223-7.80518Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M21.17383,19.19238a.73236.73236,0,0,1-.1211-.00976.74969.74969,0,0,1-.62011-.85987A2.7438,2.7438,0,0,1,22.69824,16.105l.00488-.04394a3.1502,3.1502,0,0,1-.5498-1.73536,2.27287,2.27287,0,1,1,4.52051-.0083,3.19344,3.19344,0,0,1-.5752,1.752l.00293.02343a2.647,2.647,0,0,1,2.26856,2.24073.74985.74985,0,0,1-1.48438.21386c-.06054-.418-.35254-.93554-1.40527-1.02734a.86693.86693,0,0,1-.7334-.61621c-.00391-.01074-.38477-1.1167.05078-1.59863a1.6562,1.6562,0,0,0,.376-1.00928c0-.43848-.13379-.98633-.76856-.98633-.18554,0-.752,0-.752,1.00781a1.64376,1.64376,0,0,0,.373,1.01465c.41211.459.03125,1.56445.02734,1.5752a.85857.85857,0,0,1-.69824.61084c-1.12988.11474-1.38672.70312-1.44238,1.04394A.74983.74983,0,0,1,21.17383,19.19238Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M39.167,32.26074a.99916.99916,0,0,1-.70019-.28613L30.27734,23.936H19.80176a4.68622,4.68622,0,0,1-4.68067-4.68116V11.252A4.68622,4.68622,0,0,1,19.80176,6.5708H45.08887A4.68706,4.68706,0,0,1,49.77051,11.252v8.00244A4.68716,4.68716,0,0,1,45.08887,23.936H40.167v7.3247a1.00095,1.00095,0,0,1-1,1ZM19.80176,8.5708A2.68362,2.68362,0,0,0,17.12109,11.252v8.00293A2.68362,2.68362,0,0,0,19.80176,21.936H30.68652a1.00058,1.00058,0,0,1,.7002.28613L38.167,28.87793V22.936a.99974.99974,0,0,1,1-1h5.92188a2.68487,2.68487,0,0,0,2.68164-2.68165V11.252A2.68445,2.68445,0,0,0,45.08887,8.5708Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M43.96875,14.65869H32.98926a.75.75,0,0,1,0-1.5H43.96875a.75.75,0,0,1,0,1.5Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M41.38477,17.604H32.98926a.75.75,0,0,1,0-1.5h8.39551a.75.75,0,0,1,0,1.5Z"
}))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M55.26562,53.625a6.67041,6.67041,0,0,1-4.71874-11.38965l4.60449-4.604a6.66709,6.66709,0,0,1,11.33105,3.85693,1.0004,1.0004,0,1,1-1.98437.25586,4.67494,4.67494,0,0,0-7.93262-2.69873l-4.60449,4.604a4.67388,4.67388,0,0,0,6.60937,6.61036l2.85254-2.85254a.99989.99989,0,0,1,1.41406,1.41406l-2.85253,2.85254A6.65261,6.65261,0,0,1,55.26562,53.625Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M62.57812,46.625a6.64633,6.64633,0,0,1-6.51757-5.25977.99962.99962,0,1,1,1.95507-.418,4.67587,4.67587,0,0,0,7.86719,2.31543l4.60449-4.604a4.67371,4.67371,0,0,0-6.60937-6.60986l-2.417,2.4165a.99989.99989,0,0,1-1.41406-1.41406l2.417-2.4165a6.67367,6.67367,0,0,1,9.4375,9.43847l-4.60449,4.60352A6.62684,6.62684,0,0,1,62.57812,46.625Z"
})))));

exports.UnsharedIllustration = UnsharedIllustration;